const DOCUMENT = 'INVOICE_LIST_';

const actions = {
  LOAD_INVOICE_LINE_ITEMS_REQUEST: DOCUMENT + 'LOAD_INVOICE_LINE_ITEMS_REQUEST',
  LOAD_INVOICE_LINE_ITEMS_SUCCESS: DOCUMENT + 'LOAD_INVOICE_LINE_ITEMS_SUCCESS',
  LOAD_INVOICE_LINE_ITEMS_ERROR: DOCUMENT + 'LOAD_INVOICE_LINE_ITEMS_ERROR',
  HOLD_INVOICE_LINE_ITEMS_REQUEST: DOCUMENT + 'HOLD_INVOICE_LINE_ITEMS_REQUEST',
  HOLD_INVOICE_LINE_ITEMS_SUCCESS: DOCUMENT + 'HOLD_INVOICE_LINE_ITEMS_SUCCESS',
  HOLD_INVOICE_LINE_ITEMS_ERROR: DOCUMENT + 'HOLD_INVOICE_LINE_ITEMS_ERROR',
  UN_HOLD_INVOICE_LINE_ITEMS_REQUEST: DOCUMENT + 'UN_HOLD_INVOICE_LINE_ITEMS_REQUEST',
  UN_HOLD_INVOICE_LINE_ITEMS_SUCCESS: DOCUMENT + 'UN_HOLD_INVOICE_LINE_ITEMS_SUCCESS',
  UN_HOLD_INVOICE_LINE_ITEMS_ERROR: DOCUMENT + 'UN_HOLD_INVOICE_LINE_ITEMS_ERROR',
  LOAD_CONSOLIDATED_INVOICES_REQUEST: DOCUMENT + 'LOAD_CONSOLIDATED_INVOICES_REQUEST',
  LOAD_CONSOLIDATED_INVOICES_SUCCESS: DOCUMENT + 'LOAD_CONSOLIDATED_INVOICES_SUCCESS',
  LOAD_CONSOLIDATED_INVOICES_ERROR: DOCUMENT + 'LOAD_CONSOLIDATED_INVOICES_ERROR',
  PAY_CONSOLIDATED_INVOICES_REQUEST: DOCUMENT + 'PAY_CONSOLIDATED_INVOICES_REQUEST',
  PAY_CONSOLIDATED_INVOICES_SUCCESS: DOCUMENT + 'PAY_CONSOLIDATED_INVOICES_SUCCESS',
  PAY_CONSOLIDATED_INVOICES_ERROR: DOCUMENT + 'PAY_CONSOLIDATED_INVOICES_ERROR',
  PAY_PARTIALLY_CONSOLIDATED_INVOICES_REQUEST: DOCUMENT + 'PAY_PARTIALLY_CONSOLIDATED_INVOICES_REQUEST',
  PAY_PARTIALLY_CONSOLIDATED_INVOICES_SUCCESS: DOCUMENT + 'PAY_PARTIALLY_CONSOLIDATED_INVOICES_SUCCESS',
  PAY_PARTIALLY_CONSOLIDATED_INVOICES_ERROR: DOCUMENT + 'PAY_PARTIALLY_CONSOLIDATED_INVOICES_ERROR',
  MARK_AS_PENDING_CONSOLIDATED_INVOICES_REQUEST: DOCUMENT + 'MARK_AS_PENDING_CONSOLIDATED_INVOICES_REQUEST',
  MARK_AS_PENDING_CONSOLIDATED_INVOICES_SUCCESS: DOCUMENT + 'MARK_AS_PENDING_CONSOLIDATED_INVOICES_SUCCESS',
  MARK_AS_PENDING_CONSOLIDATED_INVOICES_ERROR: DOCUMENT + 'MARK_AS_PENDING_CONSOLIDATED_INVOICES_ERROR',
  LOAD_CREATE_CONSOLIDATED_INVOICE_REQUEST: DOCUMENT + 'LOAD_CREATE_CONSOLIDATED_INVOICE_REQUEST',
  LOAD_CREATE_CONSOLIDATED_INVOICE_SUCCESS: DOCUMENT + 'LOAD_CREATE_CONSOLIDATED_INVOICE_SUCCESS',
  LOAD_CREATE_CONSOLIDATED_INVOICE_ERROR: DOCUMENT + 'LOAD_CREATE_CONSOLIDATED_INVOICE_ERROR',
  CREATE_CONSOLIDATED_INVOICE_REQUEST: DOCUMENT + 'CREATE_CONSOLIDATED_INVOICE_REQUEST',
  CREATE_CONSOLIDATED_INVOICE_SUCCESS: DOCUMENT + 'CREATE_CONSOLIDATED_INVOICE_SUCCESS',
  CREATE_CONSOLIDATED_INVOICE_ERROR: DOCUMENT + 'CREATE_CONSOLIDATED_INVOICE_ERROR',
  SHOW_CONSOLIDATED_INVOICE_REQUEST: DOCUMENT + 'SHOW_CONSOLIDATED_INVOICE_REQUEST',
  SHOW_CONSOLIDATED_INVOICE_SUCCESS: DOCUMENT + 'SHOW_CONSOLIDATED_INVOICE_SUCCESS',
  SHOW_CONSOLIDATED_INVOICE_ERROR: DOCUMENT + 'SHOW_CONSOLIDATED_INVOICE_ERROR',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CLEAR_INVOICE_LINE_ITEMS_MODAL: DOCUMENT + 'CLEAR_INVOICE_LINE_ITEMS_MODAL',
  CLEAR_CONSOLIDATED_INVOICES_MODAL: DOCUMENT + 'CLEAR_CONSOLIDATED_INVOICES_MODAL',
  CLEAR_CREATE_CONSOLIDATED_INVOICE_ERROR: DOCUMENT + 'CLEAR_CREATE_CONSOLIDATED_INVOICE_ERROR',
  TOUCH: DOCUMENT + 'TOUCH',

  loadInvoiceLineItemsRequest: data => ({
    type: actions.LOAD_INVOICE_LINE_ITEMS_REQUEST,
    payload: data,
  }),

  loadInvoiceLineItemsSuccess: data => ({
    type: actions.LOAD_INVOICE_LINE_ITEMS_SUCCESS,
    payload: data,
  }),

  loadInvoiceLineItemsError: () => ({
    type: actions.LOAD_INVOICE_LINE_ITEMS_ERROR,
  }),

  holdInvoiceLineItemsRequest: data => ({
    type: actions.HOLD_INVOICE_LINE_ITEMS_REQUEST,
    payload: data,
  }),

  holdInvoiceLineItemsSuccess: data => ({
    type: actions.HOLD_INVOICE_LINE_ITEMS_SUCCESS,
    payload: data,
  }),

  holdInvoiceLineItemsError: () => ({
    type: actions.HOLD_INVOICE_LINE_ITEMS_ERROR,
  }),

  unHoldInvoiceLineItemsRequest: data => ({
    type: actions.UN_HOLD_INVOICE_LINE_ITEMS_REQUEST,
    payload: data,
  }),

  unHoldInvoiceLineItemsSuccess: data => ({
    type: actions.UN_HOLD_INVOICE_LINE_ITEMS_SUCCESS,
    payload: data,
  }),

  unHoldInvoiceLineItemsError: () => ({
    type: actions.UN_HOLD_INVOICE_LINE_ITEMS_ERROR,
  }),

  loadConsolidatedInvoicesRequest: data => ({
    type: actions.LOAD_CONSOLIDATED_INVOICES_REQUEST,
    payload: data,
  }),

  loadConsolidatedInvoicesSuccess: data => ({
    type: actions.LOAD_CONSOLIDATED_INVOICES_SUCCESS,
    payload: data,
  }),

  loadConsolidatedInvoicesError: () => ({
    type: actions.LOAD_CONSOLIDATED_INVOICES_ERROR,
  }),

  payConsolidatedInvoicesRequest: data => ({
    type: actions.PAY_CONSOLIDATED_INVOICES_REQUEST,
    payload: data,
  }),

  payConsolidatedInvoicesSuccess: data => ({
    type: actions.PAY_CONSOLIDATED_INVOICES_SUCCESS,
    payload: data,
  }),

  payConsolidatedInvoicesError: () => ({
    type: actions.PAY_CONSOLIDATED_INVOICES_ERROR,
  }),

  payPartiallyConsolidatedInvoicesRequest: data => ({
    type: actions.PAY_PARTIALLY_CONSOLIDATED_INVOICES_REQUEST,
    payload: data,
  }),

  payPartiallyConsolidatedInvoicesSuccess: data => ({
    type: actions.PAY_PARTIALLY_CONSOLIDATED_INVOICES_SUCCESS,
    payload: data,
  }),

  payPartiallyConsolidatedInvoicesError: () => ({
    type: actions.PAY_PARTIALLY_CONSOLIDATED_INVOICES_ERROR,
  }),

  markAsPendingConsolidatedInvoicesRequest: data => ({
    type: actions.MARK_AS_PENDING_CONSOLIDATED_INVOICES_REQUEST,
    payload: data,
  }),

  markAsPendingConsolidatedInvoicesSuccess: data => ({
    type: actions.MARK_AS_PENDING_CONSOLIDATED_INVOICES_SUCCESS,
    payload: data,
  }),

  markAsPendingConsolidatedInvoicesError: () => ({
    type: actions.MARK_AS_PENDING_CONSOLIDATED_INVOICES_ERROR,
  }),

  loadCreateConsolidatedInvoiceRequest: data => ({
    type: actions.LOAD_CREATE_CONSOLIDATED_INVOICE_REQUEST,
    payload: data,
  }),

  loadCreateConsolidatedInvoiceSuccess: data => ({
    type: actions.LOAD_CREATE_CONSOLIDATED_INVOICE_SUCCESS,
    payload: data,
  }),

  loadCreateConsolidatedInvoiceError: data => ({
    type: actions.LOAD_CREATE_CONSOLIDATED_INVOICE_ERROR,
    payload: data,
  }),

  createConsolidatedInvoiceRequest: data => ({
    type: actions.CREATE_CONSOLIDATED_INVOICE_REQUEST,
    payload: data,
  }),

  createConsolidatedInvoiceSuccess: data => ({
    type: actions.CREATE_CONSOLIDATED_INVOICE_SUCCESS,
    payload: data,
  }),

  createConsolidatedInvoiceError: () => ({
    type: actions.CREATE_CONSOLIDATED_INVOICE_ERROR,
  }),

  showConsolidatedInvoiceRequest: data => ({
    type: actions.SHOW_CONSOLIDATED_INVOICE_REQUEST,
    payload: data,
  }),

  showConsolidatedInvoiceSuccess: data => ({
    type: actions.SHOW_CONSOLIDATED_INVOICE_SUCCESS,
    payload: data,
  }),

  showConsolidatedInvoiceError: () => ({
    type: actions.SHOW_CONSOLIDATED_INVOICE_ERROR,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  clearConsolidatedInvoiceModal: () => ({
    type: actions.CLEAR_CONSOLIDATED_INVOICES_MODAL,
  }),

  clearInvoiceLineItemsModal: () => ({
    type: actions.CLEAR_INVOICE_LINE_ITEMS_MODAL,
  }),

  clearCreateConsolidatedInvoiceError: () => ({
    type: actions.CLEAR_CREATE_CONSOLIDATED_INVOICE_ERROR,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
